import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.196 8.75C13.0938 8.75 12.2 9.64379 12.2 10.746V13.253C12.2 14.3552 13.0938 15.249 14.196 15.249C15.2982 15.249 16.192 14.3552 16.192 13.253V10.746C16.192 9.64379 15.2982 8.75 14.196 8.75ZM13.7 10.746C13.7 10.4722 13.9222 10.25 14.196 10.25C14.4698 10.25 14.692 10.4722 14.692 10.746V13.253C14.692 13.5268 14.4698 13.749 14.196 13.749C13.9222 13.749 13.7 13.5268 13.7 13.253V10.746Z"
    }, null, -1),
    _createElementVNode("path", { d: "M10.1243 8.807C10.4047 8.92301 10.5875 9.19657 10.5875 9.50002V13.75H11.2091C11.6233 13.75 11.9591 14.0858 11.9591 14.5C11.9591 14.9142 11.6233 15.25 11.2091 15.25H9.89417C9.87548 15.2514 9.85659 15.2521 9.83755 15.2521C9.8185 15.2521 9.79962 15.2514 9.78092 15.25H8.55C8.13579 15.25 7.8 14.9142 7.8 14.5C7.8 14.0858 8.13579 13.75 8.55 13.75H9.08755V11.311C8.79325 11.5742 8.34104 11.5648 8.05812 11.2823C7.76499 10.9896 7.76461 10.5148 8.05727 10.2216L9.30679 8.97012C9.5212 8.75537 9.84388 8.69098 10.1243 8.807Z" }, null, -1)
  ])))
}
export default { render: render }